/* eslint-disable */
import { useParameter, useExport } from "../../../shared";
import * as React from "react";
import { REPORT_ID } from "../constants";

export function useExportQuery(title, subtitle) {
  const exportBuilder = useExport();
  const [commodities] = useParameter<number[]>("@commodities");
  const [commodities_display] = useParameter<string[]>("@commodities_display");
  const [calendar] = useParameter<number[]>("@calendar");
  const [eCalendar] = useParameter<number[]>("@e_calendar");
  const [e_countries] = useParameter<number[]>("@e_countries");

  React.useEffect(() => {
    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('reportDefinition', {
      reportId: exportBuilder.reportId,
      name: { 9: title },
      parameters: {
        "@commodities": commodities && commodities.map(String),
        "@e_countries": e_countries && e_countries.map(String),
        "@e_calendar": eCalendar && eCalendar.map(String),
        "@commodities_display": commodities_display && commodities_display.map(String),
        "@calendar": calendar && calendar.map(String),
      }
    });
  }, [title, subtitle, exportBuilder, calendar, e_countries, eCalendar, commodities]);
}
